import { Container, Row, Col } from 'react-bootstrap';
import Footer from './components/Footer';

export default function Committees() {

  return (
    <>
      <section id="hero" className="hero hero-background  position-relative">
        <Container >
          <Row className="align-items-center">
              <Col md={8} lg={6} className=''>
                <h1 className="display-3 fw-bold text-white">Committees</h1>
              </Col>
            </Row>
        </Container>
      </section>
      <Container className='py-5'>
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className='pb-5'>
            <h2 className='h1 mb-4 purple-h'>We are the BPP 2026</h2>
              <p>
                The scientific programme is led by a <highlight>distinguished group of researchers</highlight> dedicated to advancing the field through international collaboration and innovative research.
              </p>
              <p>
                The <strong>Chair</strong> of the conference is <strong>Filipa A. Vicente</strong>, representing the National Institute of Chemistry, Slovenia.
              </p>
              <p>
                She is joined by <strong>Co-chairs</strong>:
              </p>
              <ul>
                <li><strong>Ana Rotter</strong>, National Institute of Biology, Slovenia</li>
                <li><strong>Annamaria Vujanović</strong>, University of Maribor, Slovenia</li>
                <li><strong>Gasan Osojnik</strong>, National Institute of Chemistry, Slovenia</li>
              </ul>
              <p>
                Together with other Committees they bring a wealth of expertise to ensure a high-quality and impactful scientific programme of this conference.
              </p>

            <h3 className='mt-5'>International Scientific Committee</h3>
              <ul>
                <li><strong>Adalberto Pessoa Júnior</strong>, University of São Paulo, Brazil</li>
                <li><strong>Alois Jungbauer</strong>, Austrian Centre of Industrial Biotechnology, Austria</li>
                <li><strong>Ana Azevedo</strong>, Técnico Lisboa, Portugal</li>
                <li><strong>Arne Staby</strong>, Novo Nordisk, Denmark</li>
                <li><strong>Astrid Duerauer</strong>, Austrian Centre of Industrial Biotechnology, Austria</li>
                <li><strong>Cecilia Roque</strong>, Applied Molecular Biosciences, UCIBIO, Portugal</li>
                <li><strong>James Van Alstine</strong>, JMVA Biotech AB, Sweden</li>
                <li><strong>João A. P. Coutinho</strong>, University of Aveiro, Portugal</li>
                <li><strong>Jorge F.B. Pereira</strong>, University of Coimbra, Portugal</li>
                <li><strong>Juan A. Asenjo</strong>, Universidad de Chile, Chile</li>
                <li><strong>Jurgen Hubbuch</strong>, Karlsruhe Institute of Technology (KIT), Germany</li>
                <li><strong>Leif Bülow</strong>, Lund University, Sweden</li>
                <li><strong>Marcel Ottens</strong>, Delft University of Technology, The Netherlands</li>
                <li><strong>Marcelo Fernandez Lahore</strong>, Luxembourg Institute of Science and Technology</li>
                <li><strong>Marco Rito-Palomares</strong>, The Institute for Obesity Research - Tecnológico de Monterrey</li>
                <li><strong>Mara G. Freire</strong>, University of Aveiro, Portugal</li>
                <li><strong>Oliver Kaltenbrunner</strong>, Amgen, USA</li>
                <li><strong>Raquel Aires-Barros</strong>, Técnico Lisboa, Portugal</li>
                <li><strong>Richard Willson</strong>, University of Houston, USA</li>
                <li><strong>Robin D. Rogers</strong>, University of Alabama, USA</li>
                <li><strong>Todd Przybycien</strong>, Rensselaer Polytechnic Institute, USA</li>
                
            </ul>


              <h3 className='mt-5'>National Scientific Committee</h3>
              <ul>
                <li><strong>Filipa A. Vicente</strong>, National Institute of Chemistry, Slovenia</li>
                <li><strong>Gasan Osojnik</strong>, National Institute of Chemistry, Slovenia</li>
                <li><strong>Ana Rotter</strong>, National Institute of Biology, Slovenia</li>
                <li><strong>Annamaria Vujanović</strong>, University of Maribor, Slovenia</li>
                <li><strong>Maša Knez Marevci</strong>, University of Maribor, Slovenia</li>
                <li><strong>Maja Čič</strong>, National Institute of Chemistry, Slovenia</li>
                <li><strong>Giorgio Tofani</strong>, National Institute of Chemistry, Slovenia</li>
                <li><strong>Brigita Hočevar</strong>, National Institute of Chemistry, Slovenia</li>
                <li><strong>Anja Verbič</strong>, National Institute of Chemistry, Slovenia</li>
              </ul>

              <h3 className='mt-5'>Organising Committee</h3>
              <ul>
                  <li><strong>Filipa A. Vicente</strong>, National Institute of Chemistry, Slovenia</li>
                  <li><strong>Gasan Osojnik</strong>, National Institute of Chemistry, Slovenia</li>
                  <li><strong>Ana Rotter</strong>, National Institute of Biology, Slovenia</li>
                  <li><strong>Annamaria Vujanović</strong>, University of Maribor, Slovenia</li>
                  <li><strong>Ernesta Grigalionyte-Bembič</strong>, National Institute of Biology, Slovenia</li>
                  <li><strong>Maja Čič</strong>, National Institute of Chemistry, Slovenia</li>
                  <li><strong>Giorgio Tofani</strong>, National Institute of Chemistry, Slovenia</li>
                  <li><strong>Brigita Hočevar</strong>, National Institute of Chemistry, Slovenia</li>
                  <li><strong>Anja Verbič</strong>, National Institute of Chemistry, Slovenia</li>
              </ul>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
 